(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["granite-team-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('granite-team-directory')) {
    customElements.define('granite-team-directory', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.resizeObservers = [];
        this.querySelectorAll('[data-team-carousel]').forEach(carousel => {
          const strip = carousel.querySelector('[data-team-strip]');
          const previous = carousel.querySelector('[data-team-previous]');
          const next = carousel.querySelector('[data-team-next]');
          const update = () => {
            const max = strip.scrollWidth - strip.clientWidth;
            previous.hidden = next.hidden = max <= 2;
            previous.disabled = strip.scrollLeft <= 2;
            next.disabled = strip.scrollLeft >= max - 2;
          };
          const move = direction => {
            strip.scrollBy({left: direction * Math.max(strip.clientWidth * .8, 112), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
          };
          previous.addEventListener('click', () => move(-1), {signal: this.controller.signal});
          next.addEventListener('click', () => move(1), {signal: this.controller.signal});
          strip.addEventListener('scroll', update, {passive: true, signal: this.controller.signal});
          if ('ResizeObserver' in window) {
            const observer = new ResizeObserver(update);
            observer.observe(strip);
            this.resizeObservers.push(observer);
          } else {
            window.addEventListener('resize', update, {signal: this.controller.signal});
          }
          update();
        });
        this.querySelectorAll('[data-team-search]').forEach(input => {
          input.addEventListener('input', () => {
            const body = input.closest('.gtd__body');
            const search = input.value.trim().toLocaleLowerCase();
            let count = 0;
            body.querySelectorAll('[data-team-name]').forEach(item => {
              item.hidden = !item.dataset.teamName.includes(search);
              if (!item.hidden) count++;
            });
            body.querySelector('.gtd__no-results').hidden = count > 0;
          }, { signal: this.controller.signal });
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObservers?.forEach(observer => observer.disconnect());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["granite-wholesale-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('granite-wholesale-header')) {
    customElements.define('granite-wholesale-header', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const dropdowns = [...this.querySelectorAll('details')];
        const closeAll = () => dropdowns.forEach(item => { item.open = false; });
        dropdowns.forEach(item => {
          item.addEventListener('toggle', () => {
            if (item.open) dropdowns.forEach(other => { if (other !== item) other.open = false; });
          }, options);
          const wrapper = item.closest('.gwh__nav-item');
          wrapper.addEventListener('pointerenter', event => {
            if (event.pointerType === 'mouse' && window.matchMedia('(min-width: 750px)').matches) item.open = true;
          }, options);
          wrapper.addEventListener('pointerleave', event => {
            if (event.pointerType === 'mouse' && !wrapper.contains(document.activeElement)) item.open = false;
          }, options);
        });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const open = dropdowns.find(item => item.open);
          closeAll();
          if (open) open.querySelector('summary').focus();
        }, options);
        document.addEventListener('pointerdown', event => {
          if (!this.contains(event.target)) closeAll();
        }, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
